import React from 'react'
import { Grid } from '@material-ui/core'
import { StyledExternalLink } from '../../../../../theme/Global'
import { LocationContentHeading } from '../LocationContent/styles'
import { DEFAULT_FEDERAL_JURISDICTION } from '../../../../constants'

const formatJurisdictionName = ({
  name,
  jurisdiction
}) => `${name} ${jurisdiction !== DEFAULT_FEDERAL_JURISDICTION ? ` - ${jurisdiction}` : null}`

const ApplicableJurisdictions = ({
  applicableJurisdictions,
  setCurrentJurisdiction,
  focusedJurisdiction
}) => (
  <Grid container data-testid="applicable-jurisdictions">
    <Grid item xs={6}>
      <LocationContentHeading>Applicable Jurisdiction(s):</LocationContentHeading>
    </Grid>
    <Grid item xs={6}>
      <Grid container spacing={24}>
        {applicableJurisdictions.map((jurisdiction) => ([
          <Grid item xs={12} key={`${jurisdiction.id}-${jurisdiction.name}`}>
            <StyledExternalLink
              tabIndex="0"
              isActive
              data-active
              role="button"
              onClick={() => {
                setCurrentJurisdiction(jurisdiction)
              }}
              className={
                focusedJurisdiction.id === jurisdiction.id ? 'activeContent' : null
              }
              data-testid={`paidLeave-details-jurisdiction-button-${jurisdiction.jurisdiction}`}
            >
              {formatJurisdictionName(jurisdiction)}
            </StyledExternalLink>
          </Grid>
        ]))}
      </Grid>
    </Grid>
  </Grid>
)


export default ApplicableJurisdictions
